/* Shine Theme — vanilla JS bundle */

(function () {
  'use strict';

  const $ = (sel, root) => (root || document).querySelector(sel);
  const $$ = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* ===================================================
     Mega menu
     =================================================== */
  function initMegaMenu() {
    $$('[data-megamenu]').forEach(item => {
      const trigger = $('.nav-link', item);
      if (!trigger) return;
      const open  = () => item.classList.add('is-open');
      const close = () => item.classList.remove('is-open');
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        item.classList.toggle('is-open');
      });
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') $$('[data-megamenu].is-open').forEach(i => i.classList.remove('is-open'));
    });
  }

  /* ===================================================
     Mobile drawer
     =================================================== */
  function initDrawer() {
    const btn = $('[data-open-drawer]');
    const drawer = $('#mobile-drawer');
    if (!btn || !drawer) return;
    const open  = () => drawer.classList.add('is-open');
    const close = () => drawer.classList.remove('is-open');
    btn.addEventListener('click', open);
    drawer.addEventListener('click', (e) => {
      if (e.target === drawer || e.target.classList.contains('close')) close();
    });
  }

  /* ===================================================
     Accordion
     =================================================== */
  function initAccordion() {
    $$('.accordion-trigger').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const item = trigger.parentElement;
        item.classList.toggle('is-open');
        const isOpen = item.classList.contains('is-open');
        trigger.setAttribute('aria-expanded', String(isOpen));
      });
    });
  }

  /* ===================================================
     Product gallery
     =================================================== */
  function initGallery() {
    const gallery = $('[data-gallery]');
    if (!gallery) return;
    const main = $('[data-gallery-main] img', gallery);
    gallery.addEventListener('click', (e) => {
      const thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      $$('[data-thumb]', gallery).forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const src = thumb.dataset.src;
      const srcset = thumb.dataset.srcset;
      if (src && main) main.src = src;
      if (srcset && main) main.srcset = srcset;
    });
  }

  /* ===================================================
     Variant picker
     =================================================== */
  class VariantPicker {
    constructor(form) {
      this.form = form;
      this.productJson = JSON.parse($('[data-product-json]', form)?.textContent || '{}');
      this.variants = this.productJson.variants || [];
      this.optionInputs = $$('[data-option]', form);
      this.priceEl = $('[data-price]');
      this.compareEl = $('[data-compare-price]');
      this.stockEl = $('[data-stock]');
      this.idInput = $('input[name="id"]', form);
      this.addBtn = $('[data-add-to-cart]', form);
      this.mainImage = $('[data-gallery-main] img');

      this.optionInputs.forEach(btn => {
        btn.addEventListener('click', () => {
          const opt = btn.dataset.option;
          const val = btn.dataset.value;
          $$(`[data-option="${opt}"]`, form).forEach(b => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          this.update();
        });
      });
      this.update();
    }

    selectedOptions() {
      const opts = {};
      this.optionInputs.forEach(btn => {
        if (btn.classList.contains('is-active')) opts[btn.dataset.option] = btn.dataset.value;
      });
      return opts;
    }

    matchVariant(opts) {
      return this.variants.find(v => {
        return Object.keys(opts).every((k, i) => v.options[i] === opts[k]);
      });
    }

    update() {
      const opts = this.selectedOptions();
      const variant = this.matchVariant(opts) || this.variants[0];
      if (!variant) return;

      if (this.idInput) this.idInput.value = variant.id;

      if (this.priceEl) this.priceEl.textContent = formatMoney(variant.price);
      if (this.compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          this.compareEl.textContent = formatMoney(variant.compare_at_price);
          this.compareEl.hidden = false;
        } else {
          this.compareEl.hidden = true;
        }
      }
      if (this.stockEl) {
        if (variant.available) {
          this.stockEl.classList.remove('stock--out');
          this.stockEl.querySelector('.label').textContent = 'In stock — ships in 1–2 days';
        } else {
          this.stockEl.classList.add('stock--out');
          this.stockEl.querySelector('.label').textContent = 'Sold out';
        }
      }
      if (this.addBtn) {
        this.addBtn.disabled = !variant.available;
        this.addBtn.querySelector('.label').textContent = variant.available ? 'Add to bag' : 'Sold out';
      }
      // Featured image swap
      if (variant.featured_image && this.mainImage) {
        this.mainImage.src = variant.featured_image.src || variant.featured_image;
      }
    }
  }

  function initVariantPickers() {
    $$('[data-variant-picker]').forEach(form => {
      try { new VariantPicker(form); } catch (e) { console.warn('VariantPicker init failed:', e); }
    });
  }

  /* ===================================================
     Size display pills (single-variant products) — visual toggle only
     =================================================== */
  function initSizePills() {
    document.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-size-pill]');
      if (!pill) return;
      const row = pill.closest('[data-size-display]');
      if (!row) return;
      $$('[data-size-pill]', row).forEach(b => b.classList.remove('is-active'));
      pill.classList.add('is-active');
    });
  }

  /* ===================================================
     Quantity stepper
     =================================================== */
  function initQty() {
    $$('[data-qty]').forEach(wrap => {
      const input = $('input', wrap);
      $('[data-qty-decr]', wrap)?.addEventListener('click', () => {
        input.value = Math.max(1, (+input.value || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      $('[data-qty-incr]', wrap)?.addEventListener('click', () => {
        input.value = (+input.value || 1) + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* ===================================================
     Add to cart — Shopify AJAX API (event-delegated)
     =================================================== */
  function initAddToCart() {
    // Event delegation on document so dynamically-rendered forms also work
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();

      const submit = form.querySelector('[data-add-to-cart]');
      const label = submit?.querySelector('.label');
      const originalText = label?.textContent || 'Add to bag';

      if (submit) { submit.disabled = true; if (label) label.textContent = 'Adding…'; }

      try {
        const formData = new FormData(form);
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/javascript' },
          body: formData
        });
        if (!res.ok) {
          const txt = await res.text();
          let msg = 'Could not add to bag';
          try { msg = JSON.parse(txt).description || msg; } catch {}
          throw new Error(msg);
        }
        await refreshCartCount();
        await openCartDrawer();
      } catch (err) {
        toast(err.message || 'Could not add to bag');
      } finally {
        if (submit) { submit.disabled = false; if (label) label.textContent = originalText; }
      }
    });
  }

  async function refreshCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      $$('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
      });
      return cart;
    } catch { return null; }
  }

  /* ===================================================
     Cart drawer — right-side, full-height, slide-in
     =================================================== */
  let cartListenersBound = false;

  async function openCartDrawer() {
    const drawer = $('#cart-drawer');
    if (!drawer) return;

    drawer.removeAttribute('hidden');
    await renderCartContents(drawer);
    // Trigger slide-in on next frame so transition applies
    requestAnimationFrame(() => drawer.classList.add('is-open'));

    bindCartListeners(drawer);
  }

  function closeCartDrawer() {
    const drawer = $('#cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    // Hide after slide-out completes
    setTimeout(() => drawer.setAttribute('hidden', ''), 350);
  }

  async function renderCartContents(drawer) {
    drawer.innerHTML = '<div class="cart-drawer__panel"><div style="padding:60px 24px;text-align:center;color:#6F6F86">Loading…</div></div>';
    try {
      const res = await fetch('/?section_id=cart-drawer');
      if (res.ok) {
        const html = await res.text();
        drawer.innerHTML = new DOMParser().parseFromString(html, 'text/html').body.innerHTML;
        return;
      }
    } catch {}
    // Fallback: minimal inline render from /cart.js
    const cart = await (await fetch('/cart.js')).json();
    drawer.innerHTML = renderCartFallback(cart);
  }

  function renderCartFallback(cart) {
    if (!cart.items || cart.items.length === 0) {
      return `
        <div class="cart-drawer__panel">
          <header class="cart-drawer__head"><h3>Your bag</h3><button data-close-cart class="cart-drawer__close" aria-label="Close">&times;</button></header>
          <div class="cart-drawer__empty">
            <p>Your bag is empty.</p>
            <a href="/" class="btn btn--primary" data-close-cart>Continue shopping</a>
          </div>
        </div>`;
    }
    const lines = cart.items.map(item => `
      <li class="cart-line">
        <a href="${item.url}" class="cart-line__image"><img src="${item.image}" alt="${item.product_title}" width="80" height="80"></a>
        <div class="cart-line__info">
          <a href="${item.url}" class="cart-line__title">${item.product_title}</a>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__meta">${item.variant_title}</div>` : ''}
          <div class="cart-line__bottom">
            <span class="cart-line__qty"><span class="cart-line__qty-val">Qty ${item.quantity}</span></span>
            <span class="cart-line__price">${formatMoney(item.line_price)}</span>
          </div>
        </div>
      </li>
    `).join('');
    return `
      <div class="cart-drawer__panel">
        <header class="cart-drawer__head">
          <h3>Your bag <span class="cart-drawer__count">${cart.item_count}</span></h3>
          <button data-close-cart class="cart-drawer__close" aria-label="Close">&times;</button>
        </header>
        <ul class="cart-drawer__lines">${lines}</ul>
        <footer class="cart-drawer__foot">
          <div class="cart-drawer__subtotal"><span>Subtotal</span><strong>${formatMoney(cart.total_price)}</strong></div>
          <p class="cart-drawer__note">Shipping &amp; taxes calculated at checkout</p>
          <a href="/checkout" class="btn btn--primary btn--block">Checkout</a>
          <a href="/cart" class="btn btn--ghost btn--block">View bag</a>
        </footer>
      </div>`;
  }

  function bindCartListeners(drawer) {
    if (cartListenersBound) return;
    cartListenersBound = true;

    // Click outside (backdrop) or close button
    drawer.addEventListener('click', async (e) => {
      if (e.target === drawer || e.target.closest('[data-close-cart]')) {
        e.preventDefault();
        closeCartDrawer();
        return;
      }
      // Qty change links (delegated)
      const qtyLink = e.target.closest('[data-cart-change]');
      if (qtyLink) {
        e.preventDefault();
        const key = qtyLink.dataset.cartChange;
        const newQty = parseInt(qtyLink.dataset.qty, 10);
        await updateCartLine(key, newQty);
      }
    });

    // Esc key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeCartDrawer();
    });
  }

  async function updateCartLine(key, qty) {
    const drawer = $('#cart-drawer');
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await refreshCartCount();
      await renderCartContents(drawer);
    } catch {
      toast('Could not update bag');
    }
  }

  function bindOpenCart() {
    $$('[data-open-cart]').forEach(btn => btn.addEventListener('click', (e) => { e.preventDefault(); openCartDrawer(); }));
  }

  /* ===================================================
     Money formatter
     =================================================== */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EGP';
    const value = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${currency} ${value}`;
  }

  /* ===================================================
     Toast
     =================================================== */
  let toastTimer;
  function toast(msg) {
    let t = $('.toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'toast';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(() => t.classList.add('is-visible'));
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-visible'), 1800);
  }

  /* ===================================================
     Predictive search overlay
     =================================================== */
  function initSearchOverlay() {
    const overlay = $('#search-overlay');
    const input = $('[data-predictive-search-input]');
    const results = $('[data-predictive-search-results]');
    const form = $('.search-overlay__form');
    if (!overlay || !input || !results || !form) return;

    let debounceT, abortCtrl;

    const open = () => {
      overlay.removeAttribute('hidden');
      requestAnimationFrame(() => {
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        setTimeout(() => input.focus(), 50);
      });
    };
    const close = () => {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => {
        overlay.setAttribute('hidden', '');
        input.value = '';
        results.innerHTML = '';
      }, 300);
    };

    $$('[data-search-open]').forEach(btn => {
      btn.addEventListener('click', (e) => { e.preventDefault(); open(); });
    });
    $$('[data-search-close]').forEach(btn => btn.addEventListener('click', close));

    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    input.addEventListener('input', () => {
      clearTimeout(debounceT);
      const q = input.value.trim();
      if (q.length < 2) {
        results.innerHTML = '';
        return;
      }
      debounceT = setTimeout(() => fetchSuggestions(q), 220);
    });

    async function fetchSuggestions(q) {
      if (abortCtrl) abortCtrl.abort();
      abortCtrl = new AbortController();
      results.innerHTML = '<div class="search-loading">Searching…</div>';
      try {
        const url = `${window.Shopify?.routes?.root || '/'}search/suggest?q=${encodeURIComponent(q)}&section_id=predictive-search&resources[type]=product,collection,page&resources[limit]=6&resources[options][unavailable_products]=last`;
        const res = await fetch(url, { signal: abortCtrl.signal });
        if (!res.ok) throw new Error('Search request failed');
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('[data-predictive-search-inner]');
        results.innerHTML = inner ? inner.outerHTML : html;
      } catch (e) {
        if (e.name === 'AbortError') return;
        results.innerHTML = '<div class="search-loading">Could not load results.</div>';
      }
    }
  }

  /* ===================================================
     Wishlist (localStorage)
     =================================================== */
  const WISHLIST_KEY = 'shine_wishlist_v1';

  const Wishlist = {
    get() {
      try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
      catch { return []; }
    },
    set(list) { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); },
    has(handle) { return Wishlist.get().includes(handle); },
    toggle(handle) {
      const list = Wishlist.get();
      const i = list.indexOf(handle);
      if (i >= 0) list.splice(i, 1); else list.push(handle);
      Wishlist.set(list);
      return list.includes(handle);
    },
    remove(handle) {
      const list = Wishlist.get().filter(h => h !== handle);
      Wishlist.set(list);
    },
    count() { return Wishlist.get().length; }
  };

  function updateWishlistCount() {
    const n = Wishlist.count();
    $$('[data-wishlist-count]').forEach(el => {
      el.textContent = n;
      el.style.display = n > 0 ? 'inline-flex' : 'none';
    });
  }

  function paintWishlistButtons() {
    $$('[data-wishlist-toggle]').forEach(btn => {
      const handle = btn.dataset.handle;
      btn.classList.toggle('is-active', Wishlist.has(handle));
      btn.setAttribute('aria-pressed', Wishlist.has(handle) ? 'true' : 'false');
    });
  }

  function initWishlist() {
    paintWishlistButtons();
    updateWishlistCount();

    // Delegate toggle clicks
    document.addEventListener('click', (e) => {
      const toggle = e.target.closest('[data-wishlist-toggle]');
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        const handle = toggle.dataset.handle;
        if (!handle) return;
        const added = Wishlist.toggle(handle);
        $$(`[data-wishlist-toggle][data-handle="${handle}"]`).forEach(b => {
          b.classList.toggle('is-active', added);
          b.setAttribute('aria-pressed', added ? 'true' : 'false');
        });
        updateWishlistCount();
        toast(added ? 'Added to wishlist' : 'Removed from wishlist');
        // Re-render the wishlist page if we're on it
        if ($('[data-wishlist-grid]')) renderWishlistPage();
        return;
      }
      const remove = e.target.closest('[data-wishlist-remove]');
      if (remove) {
        e.preventDefault();
        e.stopPropagation();
        Wishlist.remove(remove.dataset.wishlistRemove);
        updateWishlistCount();
        renderWishlistPage();
      }
    });

    // Render wishlist page if present
    if ($('[data-wishlist-grid]')) renderWishlistPage();
  }

  async function renderWishlistPage() {
    const grid    = $('[data-wishlist-grid]');
    const empty   = $('[data-wishlist-empty]');
    const loading = $('[data-wishlist-loading]');
    const counter = $('[data-wishlist-pagecount]');
    if (!grid) return;

    const handles = Wishlist.get();
    if (counter) counter.textContent = handles.length;

    if (handles.length === 0) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (loading) loading.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;
    if (loading) loading.hidden = false;
    grid.hidden = false;
    grid.innerHTML = '';

    const products = await Promise.all(
      handles.map(h => fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null))
    );

    const cards = products.map((p, i) => {
      if (!p) {
        // Stale handle — purge silently
        Wishlist.remove(handles[i]);
        return '';
      }
      return wishlistCardHTML(p);
    }).filter(Boolean).join('');

    if (loading) loading.hidden = true;
    grid.innerHTML = cards;
    updateWishlistCount();

    if (cards === '') {
      grid.hidden = true;
      if (empty) empty.hidden = false;
    }
  }

  function wishlistCardHTML(p) {
    const v = p.variants[0];
    const img = p.featured_image || (p.images && p.images[0]) || '';
    const onSale = v.compare_at_price && v.compare_at_price > v.price;
    const cat = p.type || '';
    return `
      <div class="product-card fade-in wishlist-card">
        <div class="product-card__media-wrap">
          ${onSale ? `<div class="product-card__labels"><span class="badge badge--sale">Sale</span></div>` : ''}
          <button class="wishlist-remove" data-wishlist-remove="${escapeAttr(p.handle)}" aria-label="Remove from wishlist">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 6l12 12M18 6L6 18"/></svg>
          </button>
          <a class="product-card__media-link" href="${p.url}" aria-label="${escapeAttr(p.title)}">
            <div class="media">
              ${img ? `<img src="${img}" alt="${escapeAttr(p.title)}" loading="lazy">` : ''}
            </div>
          </a>
        </div>
        <div class="product-card__body">
          <a class="product-card__info-link" href="${p.url}">
            ${cat ? `<div class="product-card__type">${escapeAttr(cat)}</div>` : ''}
            <h3 class="product-card__title">${escapeAttr(p.title)}</h3>
            <div class="product-card__price">
              <span class="price-now${onSale ? ' price-now--sale' : ''}">${formatMoney(v.price)}</span>
              ${onSale ? `<span class="price-was">${formatMoney(v.compare_at_price)}</span>` : ''}
            </div>
          </a>
          ${v.available ? `
            <form class="product-card__add" action="/cart/add" method="post" data-product-form>
              <input type="hidden" name="id" value="${v.id}">
              <input type="hidden" name="quantity" value="1">
              <button type="submit" class="card-add-btn" data-add-to-cart aria-label="Add ${escapeAttr(p.title)} to bag">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M5 7h14l-1.5 11a2 2 0 0 1-2 1.7H8.5a2 2 0 0 1-2-1.7L5 7z"/><path d="M9 7V5a3 3 0 0 1 6 0v2"/></svg>
                <span class="label">Add to bag</span>
              </button>
            </form>
          ` : `<span class="card-add-btn card-add-btn--disabled">Sold out</span>`}
        </div>
      </div>
    `;
  }

  function escapeAttr(s) {
    return String(s || '').replace(/[&<>"']/g, c => ({ '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;' }[c]));
  }

  /* ===================================================
     Filter panel (collection page) — toggles sidebar / drawer
     =================================================== */
  function initFilterPanel() {
    const layout = $('[data-collection-layout]');
    const panel  = $('[data-filter-panel]');
    if (!layout || !panel) return;

    const open  = () => {
      layout.classList.add('is-open');
      panel.setAttribute('aria-hidden', 'false');
      $$('[data-filter-toggle]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    };
    const close = () => {
      layout.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      $$('[data-filter-toggle]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    };

    $$('[data-filter-toggle]').forEach(btn => {
      btn.addEventListener('click', () => {
        layout.classList.contains('is-open') ? close() : open();
      });
    });
    $$('[data-filter-close]').forEach(btn => btn.addEventListener('click', close));

    // Backdrop click on mobile drawer
    panel.addEventListener('click', (e) => {
      if (e.target === panel) close();
    });

    // Esc key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && layout.classList.contains('is-open')) close();
    });
  }

  /* ===================================================
     Bootstrap
     =================================================== */
  /* ===================================================
     Announcement marquee — auto-fill width + constant speed
     =================================================== */
  function initMarquee() {
    var SPEED = 90; // pixels per second, same feel no matter how many messages
    $$('.marquee').forEach(function (m) {
      var track = $('.marquee-track', m);
      var group = track && $('.marquee-group', track);
      if (!group) return;
      var base = Array.prototype.slice.call(group.children);
      if (!base.length) return;
      // 1) Repeat the messages until one group is at least as wide as the bar (no empty gaps)
      var guard = 0;
      while (group.scrollWidth < m.offsetWidth && guard < 50) {
        base.forEach(function (c) { group.appendChild(c.cloneNode(true)); });
        guard++;
      }
      // 2) Duplicate the filled group so the -50% scroll loops seamlessly
      var groupWidth = group.scrollWidth;
      var clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      // 3) Duration from width keeps the scroll speed constant
      track.style.setProperty('--marquee-duration', (groupWidth / SPEED) + 's');
    });
  }

  function init() {
    initMarquee();
    initMegaMenu();
    initDrawer();
    initAccordion();
    initGallery();
    initVariantPickers();
    initQty();
    initAddToCart();
    bindOpenCart();
    initFilterPanel();
    initSearchOverlay();
    initWishlist();
    initSizePills();
    refreshCartCount();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.Shine = { formatMoney, toast, refreshCartCount, openCartDrawer };
})();
